export const REASON_TYPES = {
  missingKeyFeature: "missingKeyFeature",
  poorAdoption: "poorAdoption",
  openingNewAccount: "openingNewAccount",
  mergingWithAccount: "mergingWithAccount",
  other: "other",
};
